export default __webpack_public_path__ + "static/media/hht2_ep05_timeline_q03_b.a16437bd.png";